<template>
  <div>
    <div class="row">
      <div class="col-12">
        <card class="custom-shadow-card-header">
          <div slot="header" class="text-left" style="display: inline-flex;">
            <i class="nc-icon nc-mobile text-success" style="font-size: 35px;"></i>
            <h4 class="card-title" v-if="Object.keys(chartOptions5).length > 0">Total Llamadas Recibidas Ultimo Mes: {{(chartOptions5[0] ? formatMoney(chartOptions5[0].LlamadasRecibidas, 0) : 0)}}</h4>
          </div>
          <!-- <p class="card-category">Ultimo Mes</p> -->
          <p class="card-category"><i class="fa fa-calendar-o"></i> Ultimo actualización {{currentTime}}</p>
        </card>
      </div>
    </div>
      <div class="row">
        <div class="col-xl-3 col-md-6">
          <stats-card v-if="Object.keys(chartOptions3).length > 0" v-bind:title="(chartOptions3[0] ? formatMoney(chartOptions3[0].umbral30s, 0) : 0) + ''" subTitle="Umbral<30s Si Ultimo Mes">
            <div slot="header" class="icon-success">
              <i class="nc-icon nc-mobile text-success"></i>
            </div>
            <template slot="footer">
              <i class="fa fa-calendar-o"></i> Ultimo actualización {{currentTime}}
            </template>
          </stats-card>
        </div>

        <div class="col-xl-3 col-md-6">
          <stats-card v-if="Object.keys(chartOptions3).length > 0" v-bind:title="(chartOptions3[1] ? formatMoney(chartOptions3[1].umbral30s, 0) : 0) + ''" subTitle="Umbral<30s No Ultimo Mes">
            <div slot="header" class="icon-danger">
              <i class="nc-icon nc-mobile text-danger"></i>
            </div>
            <template slot="footer">
              <i class="fa fa-calendar-o"></i> Ultimo actualización {{currentTime}}
            </template>
          </stats-card>
        </div>

        <div class="col-xl-3 col-md-6">
          <stats-card v-if="Object.keys(chartOptions4).length > 0" v-bind:title="(chartOptions4[0] ? formatMoney(chartOptions4[0].LlamadasRecibidas, 0) : 0) + ''" subTitle="Llamadas Recibidas Success">
            <div slot="header" class="icon-success">
              <i class="nc-icon nc-mobile text-success"></i>
            </div>
            <template slot="footer">
              <i class="fa fa-refresh"></i> Ultimo actualización {{currentTime}}
            </template>
          </stats-card>
        </div>

        <div class="col-xl-3 col-md-6">
          <stats-card v-if="Object.keys(chartOptions4).length > 0" v-bind:title="(chartOptions4[1] ? formatMoney(chartOptions4[1].LlamadasRecibidas, 0) : 0) + ''" subTitle="Llamadas Recibidas Abandonado">
            <div slot="header" class="icon-danger">
              <i class="nc-icon nc-mobile text-danger"></i>
            </div>
            <template slot="footer">
              <i class="fa fa-refresh"></i> Ultimo actualización {{currentTime}}
            </template>
          </stats-card>
        </div>

        <!-- <div class="col-xl-3 col-md-6">
          <stats-card title="+45K" subTitle="Followers">
            <div slot="header" class="icon-info">
              <i class="nc-icon nc-favourite-28 text-primary"></i>
            </div>
            <template slot="footer">
              <i class="fa fa-refresh"></i>Ultimo actualización {{currentTime}}
            </template>
          </stats-card>
        </div> -->

      </div>
      <div class="row">
        <div class="col-md-6">
          <card class="custom-shadow-card-header">
            <div slot="header" class="text-center">
              <h4 class="card-title">Medios de Atención</h4>
              <p class="card-category">Proyectos Dialnet</p>
            </div>
            <span v-if="Object.keys(chartOptions2).length > 0">
              <div class="row">
                <div class="col-12">
                  <highcharts :options="chartOptions2"></highcharts>
                </div>
              </div>
            </span>
            <div slot="footer" class="text-left">
              <p class="card-category"><i class="fa fa-clock-o"></i> Ultimo actualización {{currentTime}}</p>
            </div>
          </card>
          <!-- <chart-card :chart-data="pieChart.data" chart-type="Pie">
            <template slot="header">
              <h4 class="card-title">Email Statistics</h4>
              <p class="card-category">Last Campaign Performance</p>
            </template>
            <template slot="footer">
              <div class="legend">
                <i class="fa fa-circle text-info"></i> Open
                <i class="fa fa-circle text-danger"></i> Bounce
                <i class="fa fa-circle text-warning"></i> Unsubscribe
              </div>
              <hr>
              <div class="stats">
                <i class="fa fa-clock-o"></i> Campaign sent 2 days ago
              </div>
            </template>
          </chart-card> -->
        </div>

        <div class="col-md-6">
          <card class="custom-shadow-card-header">
            <div slot="header" class="text-center">
              <h4 class="card-title">Promedio de Respuestas por Proyectos</h4>
              <p class="card-category">Proyectos Dialnet</p>
            </div>
            <span v-if="Object.keys(chartOptions1).length > 0">
              <div class="row">
                <div class="col-12">
                  <highcharts :options="chartOptions1"></highcharts>
                </div>
              </div>
            </span>
            <div slot="footer" class="text-left">
              <p class="card-category"><i class="fa fa-clock-o"></i> Ultimo actualización {{currentTime}}</p>
            </div>
          </card>
          <!-- <chart-card :chart-data="lineChart.data"
                      :chart-options="lineChart.options"
                      :responsive-options="lineChart.responsiveOptions">
            <template slot="header">
              <h4 class="card-title">Users Behavior</h4>
              <p class="card-category">24 Hours performance</p>
            </template>
            <template slot="footer">
              <div class="legend">
                <i class="fa fa-circle text-info"></i> Open
                <i class="fa fa-circle text-danger"></i> Click
                <i class="fa fa-circle text-warning"></i> Click Second Time
              </div>
              <hr>
              <div class="stats">
                <i class="fa fa-history"></i> Updated 3 minutes ago
              </div>
            </template>
          </chart-card> -->
        </div>
      </div>

      <div class="row">
        <!-- <div class="col-md-6">
          <chart-card
            :chart-data="barChart.data"
            :chart-options="barChart.options"
            :chart-responsive-options="barChart.responsiveOptions"
            chart-type="Bar">
            <template slot="header">
              <h4 class="card-title">2014 Sales</h4>
              <p class="card-category">All products including Taxes</p>
            </template>
            <template slot="footer">
              <div class="legend">
                <i class="fa fa-circle text-info"></i> Tesla Model S
                <i class="fa fa-circle text-danger"></i> BMW 5 Series
              </div>
              <hr>
              <div class="stats">
                <i class="fa fa-check"></i> Data information certified
              </div>
            </template>
          </chart-card>
        </div> -->

        <!-- <div class="col-md-6">
          <card class="card-tasks" title="Tasks" subTitle="Backend development">
            <l-table :data="tableData.data">
              <template slot-scope="{row}">
                <td>
                  <Checkbox v-model="row.checked"></Checkbox>
                </td>
                <td>{{row.title}}</td>
                <td class="td-actions d-flex justify-content-end">
                  <div class="btn btn-info btn-simple btn-link" v-tooltip.top-center="editTooltip">
                    <i class="fa fa-edit"></i>
                  </div>
                  <div class="btn btn-danger btn-simple btn-link" v-tooltip.top-center="deleteTooltip">
                    <i class="fa fa-times"></i>
                  </div>
                </td>
              </template>
            </l-table>
            <div class="stats" slot="footer">
              <i class="fa fa-history"></i> Updated 3 minutes ago
            </div>
          </card>

        </div> -->
      </div>
  </div>
</template>
<script>
  //import {ChartCard, StatsCard, Card, Table as LTable, Checkbox} from 'src/components/index'
  import {StatsCard} from 'src/components/index'
  import mixinMasters from 'src/util/mixinMasters'
  import mixinCharts from "src/util/mixinCharts"
  import moment from 'moment'
  import {Chart} from 'highcharts-vue'
  import Highcharts from 'highcharts'
  import exportingInit from 'highcharts/modules/exporting'

  exportingInit(Highcharts)

  export default {
    components: {
      /* Checkbox,
      Card,
      LTable,
      ChartCard, */
      StatsCard,
      highcharts: Chart
    },
    data () {
      return {
        currentTime: moment().format('hh:mm:ss'),
        editTooltip: 'Edit Task',
        deleteTooltip: 'Remove',
        chartOptions1: {},
        chartOptions2: {},
        chartOptions3: {},
        chartOptions4: {},
        chartOptions5: {},
        init_date: moment(new Date(new Date().setDate(new Date().getDate() - new Date().getDay()))).format('YYYY-MM-DD'),
        end_date: moment(new Date(new Date().setDate(new Date().getDate() - new Date().getDay()+2))).format('YYYY-MM-DD')
        /* pieChart: {
          data: {
            labels: ['40%', '20%', '40%'],
            series: [40, 20, 40]
          }
        },
        lineChart: {
          data: {
            labels: ['9:00AM', '12:00AM', '3:00PM', '6:00PM', '9:00PM', '12:00PM', '3:00AM', '6:00AM'],
            series: [
              [287, 385, 490, 492, 554, 586, 698, 695],
              [67, 152, 143, 240, 287, 335, 435, 437],
              [23, 113, 67, 108, 190, 239, 307, 308]
            ]
          },
          options: {
            low: 0,
            high: 800,
            showArea: false,
            height: '245px',
            axisX: {
              showGrid: false
            },
            lineSmooth: true,
            showLine: true,
            showPoint: true,
            fullWidth: true,
            chartPadding: {
              right: 50
            }
          },
          responsiveOptions: [
            ['screen and (max-width: 640px)', {
              axisX: {
                labelInterpolationFnc: function (value) {
                  return value[0]
                }
              }
            }]
          ]
        },
        barChart: {
          data: {
            labels: ['Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            series: [
              [542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895],
              [412, 243, 280, 580, 453, 353, 300, 364, 368, 410, 636, 695]
            ]
          },
          options: {
            seriesBarDistance: 10,
            axisX: {
              showGrid: false
            },
            height: '245px'
          },
          responsiveOptions: [
            ['screen and (max-width: 640px)', {
              seriesBarDistance: 5,
              axisX: {
                labelInterpolationFnc (value) {
                  return value[0]
                }
              }
            }]
          ]
        },
        tableData: {
          data: [
            {title: 'Sign contract for "What are conference organizers afraid of?"', checked: false},
            {title: 'Lines From Great Russian Literature? Or E-mails From My Boss?', checked: true},
            {
              title: 'Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit',
              checked: true
            },
            {title: 'Create 4 Invisible User Experiences you Never Knew About', checked: false},
            {title: 'Read "Following makes Medium better"', checked: false},
            {title: 'Unfollow 5 enemies from twitter', checked: false}
          ]
        } */
      }
    },
    mixins: [mixinMasters, mixinCharts],
    methods: {
      getDataDashboard() {
        let self = this

        let data = {}
        data.route ='qualityusersupports/dashboard'
        data.init_date = this.init_date
        data.end_date = this.end_date

        self.saveMaster(data).then((response) => {
          self.chartOptions1 = self.columns(response.data.chart1, null)
          self.chartOptions2 = self.pieChart(response.data.chart2, null)
          self.chartOptions3 = response.data.chart3
          self.chartOptions4 = response.data.chart4
          self.chartOptions5 = response.data.chart5
          self.$emit('cotentLoading', false)
        }).catch((error) => {
          console.log(error)
          self.showMessageErrors(error)
          self.$emit('cotentLoading', false)
        })
      },
    },
    mounted() {
      this.$emit('cotentLoading', true)
      this.getDataDashboard()
    },
  }
</script>
<style>

</style>
